<template>
    <div class="CohortList panel panel-default margin-bottom-0px">
      <div class="container-fluid cohortEnrollmentPannel">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-top-15px padding-bottom-15px padding-left-0px">
          <span class="col-lg-2 col-md-4 col-sm-4 col-xs-4"> </span>
          <span class="col-lg-8 col-md-4 col-sm-4 col-xs-4 text-align-left padding-left-0px">
            <span class="glyphicon glyphicon-ok cursor-pointer" :class="{'green-tick': hasSelectedCurrCohort}" @click="performUserAction(hasSelectedCurrCohort ? 'tick_unclicked' : 'tick_clicked')"></span>
            <span class="padding-left-15px">{{getCurrCohortObjValue.CohortName}}</span>
          </span>
          <span class="col-lg-2 col-md-4 col-sm-4 col-xs-4">
            <span class="badge float-right">{{getCurrCohortObjValue.DashboardDataList.length}}</span>
          </span>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    </div>    
</template>

<script>
import AlertBox from '@/components/AlertOverlay'
import { constants } from '@/utils/constants'
import { findIndex } from 'lodash'
export default {
  props: ['currGccObj', 'selectedGroupObj', 'gccList', 'currCohortObj', 'cohortList'],
  created: function () {
    this.checkAndUpdateHasSelectedCurrCohort()
  },
  data: function () {
    return {
      constants: constants,
      showAlertDialog: false,
      errorMsg: '',
      totalAvailableCohorts: 0,
      totalPresentParticipants: 0,
      hasSelectedCurrCohort: false
    }
  },
  methods: {
    performUserAction: function (operationName) {
      console.log('operationName: ' + operationName)
      this.hasSelectedCurrCohort = !this.hasSelectedCurrCohort
      switch (operationName) {
        case 'tick_clicked':
          if (this.getSelectedCohortIds.indexOf(this.getCurrCohortObjValue.CohortId) === -1) {
            this.$store.state.selectedCohortIds.push(this.getCurrCohortObjValue.CohortId)
            console.log('Added as Not present: ' + this.getCurrCohortObjValue.CohortName)
          } else {
            console.log('Ignored as already present: ' + this.getCurrCohortObjValue.CohortName)
          }
          break
        case 'tick_unclicked':
          const foundIndex = findIndex(this.getSelectedCohortIds, (cohortId) => {
            return this.getCurrCohortObjValue.CohortId === cohortId
          })
          if (foundIndex > -1) {
            this.$store.state.selectedCohortIds.splice(foundIndex, 1)
            console.log('Found at Position: ' + foundIndex)
          } else {
            console.log('Not found in selection list: ' + this.getCurrCohortObjValue.CohortName)
          }
          break
      }
      console.log('this.$store.state.selectedCohortIds' + this.$store.state.selectedCohortIds.length)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    checkAndUpdateHasSelectedCurrCohort: function () {
      const foundIndex = findIndex(this.getSelectedCohortIds, (cohortId) => {
        return this.getCurrCohortObjValue.CohortId === cohortId
      })
      this.hasSelectedCurrCohort = foundIndex > -1
      console.log('this.hasSelectedCurrCohort:: ' + this.hasSelectedCurrCohort)
    }
  },
  components: {
    'alert-box': AlertBox
  },
  computed: {
    getCohortList: {
      get: function () {
        return this.cohortList
      }
    },
    getCurrCohortObjValue: {
      get: function () {
        return this.currCohortObj
      }
    },
    getSelectedCohortIds: {
      get: function () {
        return this.$store.state.selectedCohortIds
      },
      set: function (newValue) {
        this.$store.state.selectedCohortIds = newValue
      }
    },
    getCurrGccObjValue: {
      get: function () {
        return this.currGccObj
      }
    },
    getSelectedGroupObjValue: {
      get: function () {
        return this.selectedGroupObj
      }
    },
    getGccListValue: {
      get: function () {
        return this.gccList
      }
    },
    getCohortListValue: {
      get: function () {
        return this.getCurrGccObjValue.CohortProgressDataList
      }
    }
  },
  watch: {
    getSelectedCohortIds: function (newValue, oldValue) {
      this.checkAndUpdateHasSelectedCurrCohort()
    }
  },
  name: 'CohortList'
}
</script>

<style scoped>
.green-tick {
  color: green !important;
}
.cursor-default {
  cursor: default !important;
}
.opacity-point-3 {
  opacity: 0.3;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #fff;
}
.word-break {
  word-break: break-word;
}
.cursor-pointer {
  cursor: pointer;
}
.padding-top-15px {
  padding-top: 15px;
}
.padding-bottom-15px {
  padding-bottom: 15px;
}
.black-border {
  border: 1px solid #aaa;
}
.border-bottom-0px {
  border-bottom: 0px;
}
.padding-left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.border-top-0px {
  border-top: 0px;
}
.courseEnrollmentPannel {
  color: #333;
  background-color: #f5f5f5;
  border-color: #ddd;
  /* margin-top: 15px; */
  padding-left: 0px;
  padding-right: 0px;
}
.cohortEnrollmentPannel {
  color: #333;
  background-color: #fff;
  border-color: #ddd;
  padding-left: 0px;
  padding-right: 0px;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-left-15px {
  padding-left: 15px;
}
.margin-top-15px {
  margin-top: 15px;
}
.panel-default {
  border-color: #ddd;
}
.border-hash-ddd {
  border-color: 1px solid #ddd;
}
.border-top-ddd {
  border-top:1px solid #ddd;
} 
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/new_report/CohortList.vue